import { AxiosResponse } from 'axios';
import { Result } from '@/main/models/common/resultResponse';
import {
  SupplierInventoryImportRequest,
  LogErrorImportRequest,
  SupplierInventoryImportUploadRequest,
  ImportSaveRequest
} from '@/main/models/request';
import {
  SupplierInventoryImportResponse,
  LogErrorImportResponse,
  SupplierInventorySaveResponse
} from '@/main/models/response';
import { PaginationResponse } from '@/main/models/common/paginationResponse';

export abstract class ISupplierInventoryImportApi {
  abstract getSearchGrid(
    request: SupplierInventoryImportRequest
  ): Promise<
    AxiosResponse<PaginationResponse<SupplierInventoryImportResponse>>
  >;

  abstract getLogError(
    request: LogErrorImportRequest
  ): Promise<AxiosResponse<Result<LogErrorImportResponse>>>;

  abstract uploadImportInventory(
    request: SupplierInventoryImportUploadRequest,
    file: File
  ): Promise<AxiosResponse<Result<any>, any>>;

  abstract exportInventory(
    request: SupplierInventoryImportUploadRequest
  ): Promise<AxiosResponse<Result<string>>>;

  abstract saveImport(
    request: ImportSaveRequest
  ): Promise<AxiosResponse<Result<SupplierInventorySaveResponse>>>;

  abstract downloadImportFile(
    supplierInventoryImportGuid: string
  ): Promise<AxiosResponse<Result<string>>>;

  abstract cancelImport(
    supplierInventoryImportGuid: string
  ): Promise<AxiosResponse<Result<boolean>>>;
}
